export const ConfigMantenedorDTE = {
	barraBusqueda: {
		criterios: ["Razon Social", "Rut Cliente", "Folio", "Track Id", "Monto Total"],
		criteriosKeys: ["razonSocialReceptor", "rutReceptor", "folio", "trackId", "montoTotal"],
		criterioPrincipal: "Razon Social",
		filiales: [] as any[],
		datePicker: true,
		nombreCampoDatePicker: "Fecha Emisión (Desde - Hasta)",
	},
	table: {
		title: "Facturación Emitida",
		add: "Carga Documento",
		options: [
			{
				name: "Importar",
				active: true,
				class: "ft-upload",
			},
			{
				name: "Exportar",
				active: true,
				class: "ft-download",
			},
			{
				name: "Solicitar Soporte",
				active: true,
				class: "ft-shuffle",
			},
		],
	},
};
